import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { graphql } from 'react-apollo';
import { currentUserQuery } from '../queries';

class RedirectRouteAnonymous extends React.Component {

  render() {
    const { component: Component, data: {loading, error, currentUserContext },  ...rest } = this.props;
    return (
      <div>
        { (!loading && !error) &&
        <Route
          {...rest}
          render={props => (
            currentUserContext.uid === 0
              ? <Redirect to="/"/>
              :
              (currentUserContext.uid !== 0 && !currentUserContext.fieldVatNumber
                  ? <Redirect to="/complete-registration"/>
                  : <Component currentUser={currentUserContext} {...props} />
              )
          )}
        />
        }
      </div>
    )
  };
}

export default graphql(
  currentUserQuery, {
    options: { fetchPolicy: 'network-only' },
  }
)(RedirectRouteAnonymous);


// WEBPACK FOOTER //
// ./src/utils/RedirectRouteAnonymous.js